<template>

  <div class="reports inside-banner mobile-top">
    
    <reportsreps-tour v-if="$store.state.tour & !loading" />
    
    <!-- header -->

    <section
      class="pixelsbggrid bs-shadow"
      style="padding: 20px; min-height: 370px;"
    >
      <div>
        <div class="banner-content">
          <div class="mb10" style="margin-right: -10px;">
            <div v-if="loading" class="header-bucket-wrap text-center">
              <div class="top-back">
                <h5 class="text-white text-center top-titles mb0">Backlog</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <h2 v-if="loading" style="color: rgba(255, 255, 255, 0.6)">
                  Loading....
                </h2>
                <h2 v-else class="text-white text-center">
                  {{ noCents(reports.backlog[0].sales) }}
                </h2>
              </div>
            </div>

            <router-link
              :to="{
                path: '/reportdetails',
                query: {
                  status: reports.backlog[0].state,
                  territory: reports.backlog[0].territory,
                  acid: reports.backlog[0].acid,
                },
              }"
              v-else
              class="backlog-back"
            >
              <div class="header-bucket-wrap text-center">
                <div class="top-back">
                  <h5
                    id="reportreps-step-1"
                    class="text-white text-center top-titles mb0"
                  >
                    Backlog
                  </h5>
                  <span class="material-icons"> keyboard_arrow_down </span>
                  <h2 class="text-white text-center">
                    {{ noCents(reports.backlog[0].sales) }}
                  </h2>
                </div>
              </div>
            </router-link>
          </div>

          <div class="row-4" style="margin-right: -10px;">
            <div class="header-bucket-wrap text-center mb10">
              <div v-if="loading" class="top-back">
                <h5 class="text-white top-titles mb0">In Scheduling</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <h3 style="color: rgba(255, 255, 255, 0.6)">Loading....</h3>
              </div>

              <router-link
                :to="{
                  path: '/reportdetails',
                  query: {
                    status: reports.backlog[3].state,
                    territory: reports.backlog[3].territory,
                    acid: reports.backlog[3].acid,
                  },
                }"
                v-else
                class="top-back"
              >
                <div>
                  <h5 id="reportreps-step-2" class="text-white top-titles mb0">
                    In Scheduling
                  </h5>
                  <span class="material-icons"> keyboard_arrow_down </span>

                  <h3 v-if="reports.backlog[3].sales == 0" class="text-white">
                    $0
                  </h3>
                  <h3 v-else class="text-white">
                    {{ noCents(reports.backlog[3].sales) }}
                  </h3>
                </div>
              </router-link>
            </div>

            <div class="header-bucket-wrap text-center mb10">
              <div v-if="loading" class="top-back">
                <h5 class="text-white top-titles mb0">In Production</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <h3 style="color: rgba(255, 255, 255, 0.6)">Loading....</h3>
              </div>

              <router-link
                :to="{
                  path: '/reportdetails',
                  query: {
                    status: reports.backlog[2].state,
                    territory: reports.backlog[2].territory,
                    acid: reports.backlog[2].acid,
                  },
                }"
                v-else
                class="top-back"
              >
                <div>
                  <h5 id="reportreps-step-3" class="text-white top-titles mb0">
                    In Production
                  </h5>
                  <span class="material-icons"> keyboard_arrow_down </span>
                  <h3 v-if="reports.backlog[2].sales == 0" class="text-white">
                    $0
                  </h3>
                  <h3 v-else class="text-white">
                    {{ noCents(reports.backlog[2].sales) }}
                  </h3>
                </div>
              </router-link>
            </div>

            <div class="header-bucket-wrap text-center mb10">
              <div v-if="loading" class="top-back">
                <h5 class="text-white top-titles mb0">In Shipping</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <h3 style="color: rgba(255, 255, 255, 0.6)">Loading....</h3>
              </div>

              <router-link
                :to="{
                  path: '/reportdetails',
                  query: {
                    status: reports.backlog[4].state,
                    territory: reports.backlog[4].territory,
                    acid: reports.backlog[4].acid,
                  },
                }"
                v-else
                class="top-back"
              >
                <div>
                  <h5 id="reportreps-step-4" class="text-white top-titles mb0">
                    In Shipping
                  </h5>
                  <span class="material-icons"> keyboard_arrow_down </span>
                  <h3 v-if="reports.backlog[4].sales == 0" class="text-white">
                    $0
                  </h3>
                  <h3 v-else class="text-white">
                    {{ noCents(reports.backlog[4].sales) }}
                  </h3>
                </div>
              </router-link>
            </div>
          </div>


          <div id="reportreps-step-5" class="search-btns">
            <div class="left-side">
              <div
                class="ac-select select-ac right-space"
                style="flex-shrink: 0; flex-grow: 1;"
              >
                <select
                  v-if="loading && acFilter == null"
                  disabled
                  class="form-control"
                  id="exampleFormControlSelect1"
                  v-model="acFilter"
                >
                  <option :value="null" selected class="all-contractors">
                    Area Contractor
                  </option>
                </select>

                <select
                  v-else
                  class="form-control"
                  id="exampleFormControlSelect1"
                  v-model="acFilter"
                  v-on:change="getTerritories()"
                  :disabled="loading"
                >
                  <option :value="null" selected class="all-contractors">
                    Area Contractor
                  </option>
                  <option
                    v-for="ac in acs"
                    @click="setACFilterName(ac.acName)"
                    :key="ac.acid"
                    :value="ac.acid"
                  >
                    {{ " " + ac.acName + " (" + ac.acid + ")" }}
                  </option>
                </select>
              </div>

              <div
                class="dates ac-select select-year right-space"
                id="year"
                style="margin-bottom: 10px; flex-shrink: 0; flex-grow: 1"
              >
                <div class="year-select">
                  <select
                    v-if="loading || !this.yearRange.length"
                    disabled
                    class="form-control"
                    id="exampleFormControlSelect1"
                    v-model="yearFilter"
                  >
        
                    <option
                      v-for="(year, index) in yearRange"
                      :key="year"
                      :value="year"
                      v-bind:selected="index === 0 ? 'selected' : false"
                    >
                      {{ year }}
                    </option>
                  </select>

                  <select
                    v-else
                    class="form-control"
                    id="exampleFormControlSelect1"
                    v-model="yearFilter"
                    :disabled="loading"
                  >
              
                    <option
                      v-for="(year, index) in yearRange"
                      :key="year"
                      :value="year"
                      v-bind:selected="index === 0 ? 'selected' : false"
                    >
                      {{ year }}
                    </option>
                  </select>
                </div>
              </div>

        
              <div
                v-if="loading && this.territoryFilter == null"
                class="dates ac-select select-territory right-space"
                id="dates"
                style="margin-bottom: 10px; flex-shrink: 0; flex-grow: 1"
              >
                <div class="year-select">
                  <select
                    disabled
                    class="form-control"
                    id="exampleFormControlSelect1"
                    v-model="territoryFilter"
                  >
                    <option :value="null" selected class="all-contractors">
                      All Territories
                    </option>
                  </select>
                </div>
              </div>

              <div
                v-else-if="
                  loading &&
                  this.territoryFilter != null &&
                  !this.territories.length
                "
                class="dates ac-select select-territory right-space"
                id="dates"
                style="margin-bottom: 10px; flex-shrink: 0; flex-grow: 1"
              >
                <div class="year-select">
                  <select
                    disabled
                    class="form-control"
                    id="exampleFormControlSelect1"
                  >
                    <option selected class="all-contractors">
                      Loading Territories....
                    </option>
                  </select>
                </div>
              </div>

              <div
                v-else
                v-on:change="setTerritory"
                class="dates ac-select select-territory right-space"
                id="dates"
                style="margin-bottom: 10px; flex-shrink: 0; flex-grow: 1"
              >
                <div class="year-select">
                  <select
                    class="form-control"
                    id="exampleFormControlSelect1"
                    v-model="territoryFilter"
                    :disabled="loading"
                  >
                    <option :value="null" class="all-contractors">
                      All Territories
                    </option>

                    <option
                      v-for="territory in territories"
                      :key="territory.territoryName"
                      :value="territory.webSafeTerritory"
                      :selected="
                        territory.webSafeTerritory === territoryFilter
                          ? true
                          : false
                      "
                    >
                      {{ territory.territoryName }}
                    </option>
                  </select>
                </div>
              </div>

        
              <div
                v-if="loading && !this.reps.length"
                class="dates ac-select"
                style="margin-bottom: 10px; flex-shrink: 0; flex-grow: 1"
              >
                <div class="year-select">
                  <select
                    disabled
                    class="form-control"
                    id="exampleFormControlSelect1"
                    v-model="repFilter"
                  >
                    <option :value="null" selected class="all-contractors">
                      All Sales Reps
                    </option>
                  </select>
                </div>
              </div>

              <div
                v-else
                v-on:change="setTerritory"
                class="dates ac-select select-territory"
                id="dates"
                style="margin-bottom: 10px; flex-shrink: 0; flex-grow: 1"
              >
                <div class="year-select">
                  <select
                    class="form-control"
                    id="exampleFormControlSelect1"
                    v-model="repFilter"
                    :disabled="loading"
                  >
                    <option :value="null" class="all-contractors">
                      All Sales Reps
                    </option>

                    <option
                      v-for="rep in reps"
                      :key="rep.repId"
                      :value="rep.repId"
                    >
                      {{ rep.fullName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="search-btns">
            <div
              class="left-side"
              style="flex-grow:0!important; margin-right: auto;"
            >
              <router-link
                v-if="this.acFilter != null"
                :to="{
                  name: 'ReportsNew',
                  query: {
                    ac: this.acFilter,
                    year: this.yearFilter,
                    territory: this.territoryFilter,
                  },
                }"
                class="lh1 mrauto list-btn dib d-flex center"
              >
                <i class="material-icons">keyboard_arrow_left</i>
                All ACs
              </router-link>
              <router-link
                v-else
                :to="{ name: 'ReportsNew' }"
                class="lh1 mrauto list-btn dib d-flex center"
              >
                <i class="material-icons">keyboard_arrow_left</i>
                All ACs
              </router-link>
        

       
            </div>

            <button v-if="loading == true" disabled class="clear">
              <span class="material-icons">find_replace</span>
              {{ " " }} Clear
            </button>

            <button
              v-else-if="
                acFilter ||
                territoryFilter ||
                repFilter ||
                searchStarted == true
              "
              @click="clearSearch"
              class="clear"
            >
              <span class="material-icons">find_replace</span>
              {{ " " }} Clear
            </button>
            <button v-else disabled class="clear">
              <span class="material-icons">find_replace</span>
              {{ " " }} Clear
            </button>

            <button v-if="loading == true" disabled class="search">
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>

            <button
              v-else-if="repFilter || acFilter || territoryFilter"
              @click.prevent="searchQuery"
              class="search"
            >
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>
            <button v-else class="search" disabled>
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>
          </div>
        
        </div>
   
      </div>
      <div class="d-flex"></div>
    </section>
 
    <div
      :class="
        loading == false &&
        !reports.salesBySalesman.length &&
        !reports.shippedBySalesman.length
          ? 'message-bg'
          : ''
      "
    >
      <div class="row">
   
        <div
          v-if="loading == true"
          class="col-xs-12 col-sm-12 col-12 col-lg-12"
        >
          <div
            class="flex-box-wrap"
            style="padding: 50px 0; position: relative"
          >
            <div class="flex-internal">
              <atom-spinner
                :animation-duration="1000"
                :size="40"
                :color="'#575757'"
              />
              <p>Loading......</p>
              <p>Please be patient while we look up your data.</p>
            </div>
          </div>
        </div>

        <!-- viewing all sales people -->
        <div
          v-else-if="
            loading == false &&
            reports.salesBySalesman.length &&
            reports.shippedBySalesman.length &&
            salesPerson == null
          "
          class="col-xs-12 col-sm-12 col-12 col-lg-12"
        >
          <div class="report-card" style="padding: 20px !important">
            <div class="d-flex">
              <h2 v-if="reports.salesBySalesman.length" class="mrauto">
                Entered
              </h2>
            </div>

            <div v-if="loading == false && getUniqueEnteredNames.length">
              <div
                v-for="(person, index) in getUniqueEnteredNames"
                v-bind:key="index"
                style="margin-bottom: 15px"
              >
                <div class="rfr table-responsive">
                  <div
                    style="
                      background: #4d5967;
                      color: #fff;
                      width: 100%;
                      padding: 10px;
                    "
                  >
                    <span>{{ person }}</span> | YTD Incoming -
                    {{ noCents(getSalesmanTotal(person)) }}
                  </div>

                  <table
                    class="table-striped table-bordered"
                    style="text-align: right !important"
                  >
                    <thead></thead>

                    <tbody style="text-align: center">
                      <tr>
                        <!--
                          <td>Jan<br/><router-link :to="{ path: '/reportdetails', query: { acid: report.acid, territory: report.territory, inmonth: report.monthEntered, inyear: report.year, marketcode: report.marketCode }}">{{ getMonthSales(person, 1) | currency }}</router-link></td>
   -->
                        <td>
                          Jan<br />
                          <span v-if="getMonthSales(person, 1) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepId(person, 1),
                                inmonth: 1,
                                inyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthSales(person, 1)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthSales(person, 1)) }}</span>
                        </td>
                        <td>
                          Feb<br />
                          <span v-if="getMonthSales(person, 2) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepId(person, 2),
                                inmonth: 2,
                                inyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthSales(person, 2)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthSales(person, 2)) }}</span>
                        </td>
                        <td>
                          Mar<br />
                          <span v-if="getMonthSales(person, 3) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepId(person, 3),
                                inmonth: 3,
                                inyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthSales(person, 3)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthSales(person, 3)) }}</span>
                        </td>
                        <td>
                          Apr<br />
                          <span v-if="getMonthSales(person, 4) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepId(person, 4),
                                inmonth: 4,
                                inyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthSales(person, 4)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthSales(person, 4))}}</span>
                        </td>
                        <td>
                          May<br />
                          <span v-if="getMonthSales(person, 5) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepId(person, 5),
                                inmonth: 5,
                                inyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthSales(person, 5)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthSales(person, 5)) }}</span>
                        </td>
                        <td>
                          Jun<br />
                          <span v-if="getMonthSales(person, 6) > 0">
                           <router-link
                           class="reportLink"
                            style="color: #00b4b4"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepId(person, 6),
                                inmonth: 6,
                                inyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthSales(person, 6)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthSales(person, 6)) }}</span>
                        </td>
                        <td>
                          Jul<br />
                          <span v-if="getMonthSales(person, 7) > 0">
                           <router-link
                           class="reportLink"
                            style="color: #00b4b4"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepId(person, 7),
                                inmonth: 7,
                                inyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthSales(person, 7)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthSales(person, 7)) }}</span>
                        </td>
                        <td>
                          Aug<br />
                          <span v-if="getMonthSales(person, 8) > 0">
                           <router-link
                           class="reportLink"
                            style="color: #00b4b4"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepId(person, 8),
                                inmonth: 8,
                                inyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthSales(person, 8)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthSales(person, 8)) }}</span>
                        </td>
                        <td>
                          Sep<br />
                          <span v-if="getMonthSales(person, 9) > 0">
                           <router-link
                           class="reportLink"
                            style="color: #00b4b4"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepId(person, 9),
                                inmonth: 9,
                                inyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthSales(person, 9)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthSales(person, 9)) }}</span>
                        </td>
                        <td>
                          Oct<br />
                          <span v-if="getMonthSales(person, 10) > 0">
                           <router-link
                           class="reportLink"
                            style="color: #00b4b4"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepId(person, 10),
                                inmonth: 10,
                                inyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthSales(person, 10)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthSales(person, 10)) }}</span>
                        </td>
                        <td>
                          Nov<br />
                          <span v-if="getMonthSales(person, 11) > 0">
                           <router-link
                           class="reportLink"
                            style="color: #00b4b4"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepId(person, 11),
                                inmonth: 11,
                                inyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthSales(person, 11)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthSales(person, 11)) }}</span>
                        </td>
                        <td>
                          Dec<br />
                          <span v-if="getMonthSales(person, 12) > 0">
                           <router-link
                           class="reportLink"
                            style="color: #00b4b4"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepId(person, 12),
                                inmonth: 12,
                                inyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthSales(person, 12)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthSales(person, 12)) }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- shipped -->
            
            <div style="margin-top: 30px">
              <div class="d-flex">
                <h2 v-if="reports.shippedBySalesman.length" class="mrauto">
                  Shipped
                </h2>
              </div>
            </div>

            <div v-if="loading == false && getUniqueShippedNames.length">
              <div
                v-for="(person, index) in getUniqueShippedNames"
                v-bind:key="index"
                style="margin-bottom: 15px"
              >
                <div class="rfr table-responsive">
                  <div
                    style="
                      background: #4d5967;
                      color: #fff;
                      width: 100%;
                      padding: 10px;
                    "
                  >
                    {{ person }} | YTD Shipped -
                    {{ noCents(getSalesmanShippedTotal(person)) }}
                  </div>

                  <table
                    class="table-striped table-bordered"
                    style="text-align: right !important"
                  >
                    <thead></thead>

                    <tbody style="text-align: center">
                      <tr>
                        <td>
                          Jan<br />
                          
                           <span v-if="getMonthShipped(person, 1) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepIdShipped(person, 1),
                                shippedmonth: 1,
                                shippedyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthShipped(person, 1)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthShipped(person, 1)) }}</span>
                          
                        </td>
                        <td>
                          Feb<br />
                          <span v-if="getMonthShipped(person, 2) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepIdShipped(person, 2),
                                shippedmonth: 2,
                                shippedyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthShipped(person, 2)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthShipped(person, 2)) }}</span>
                        </td>
                        <td>
                          Mar<br />
                          <span v-if="getMonthShipped(person, 3) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepIdShipped(person, 3),
                                shippedmonth: 3,
                                shippedyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthShipped(person, 3)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthShipped(person, 3)) }}</span>
                        </td>
                        <td>
                          Apr<br />
                          <span v-if="getMonthShipped(person, 4) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepIdShipped(person, 4),
                                shippedmonth: 4,
                                shippedyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthShipped(person, 4)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthShipped(person, 4)) }}</span>
                        </td>
                        <td>
                          May<br />
                          <span v-if="getMonthShipped(person, 5) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepIdShipped(person, 5),
                                shippedmonth: 5,
                                shippedyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthShipped(person, 5)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthShipped(person, 5)) }}</span>
                        </td>
                        <td>
                          Jun<br />
                          <span v-if="getMonthShipped(person, 6) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepIdShipped(person, 6),
                                shippedmonth: 6,
                                shippedyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthShipped(person, 6)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthShipped(person, 6)) }}</span>
                        </td>
                        <td>
                          Jul<br />
                          <span v-if="getMonthShipped(person, 7) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepIdShipped(person, 7),
                                shippedmonth: 7,
                                shippedyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthShipped(person, 7)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthShipped(person, 7)) }}</span>
                        </td>
                        <td>
                          Aug<br />
                          <span v-if="getMonthShipped(person, 8) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepIdShipped(person, 8),
                                shippedmonth: 8,
                                shippedyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthShipped(person, 8)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthShipped(person, 8)) }}</span>
                        </td>
                        <td>
                          Sep<br />
                          <span v-if="getMonthShipped(person, 9) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepIdShipped(person, 9),
                                shippedmonth: 9,
                                shippedyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthShipped(person, 9)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthShipped(person, 9)) }}</span>
                        </td>
                        <td>
                          Oct<br />
                          <span v-if="getMonthShipped(person, 10) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepIdShipped(person, 10),
                                shippedmonth: 10,
                                shippedyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthShipped(person, 10)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthShipped(person, 10)) }}</span>
                        </td>
                        <td>
                          Nov<br />
                          <span v-if="getMonthShipped(person, 11) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepIdShipped(person, 11),
                                shippedmonth: 11,
                                shippedyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthShipped(person, 11)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthShipped(person, 11)) }}</span>
                        </td>
                        <td>
                          Dec<br />
                          <span v-if="getMonthShipped(person, 12) > 0">
                           <router-link
                            style="color: #00b4b4"
                            class="reportLink"
                            :to="{
                              path: '/reportdetails',
                              query: {
                                acid: acFilter,
                                repid: getRepIdShipped(person, 12),
                                shippedmonth: 12,
                                shippedyear: yearFilter,
                              }
                            }"
                            >
                          {{ noCents(getMonthShipped(person, 12)) }}
                          </router-link>
                          </span>
                          <span v-else>{{ noCents(getMonthShipped(person, 12)) }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            
          </div>

          <!-- bottom disclaimer -->
          <div
            v-if="
              reports.salesBySalesman.length && reports.shippedBySalesman.length
            "
            class="report-card"
            style="padding: 10px 20px 20px !important"
          >
            <h6 class="disclaimer mt10" v-if="loading != true">
              *Credits displayed on this page reflect SSC net materials only,
              they do not include Wood Designs or DLA credits.
            </h6>
          </div>
        </div>
        <!-- end other column -->

        <!-- if they have an individual salesperson selected -->
        <div
          v-else-if="loading == false && salesPerson != null"
          class="col-xs-12 col-sm-12 col-12 col-lg-12"
        >
          <div class="report-card" style="padding: 20px !important">
            <div class="d-flex">
              <h2 class="mrauto">Entered</h2>
            </div>

            <div class="rfr table-responsive">
              <table
                class="table-striped table-bordered"
                style="text-align: right !important"
              >
                <thead>
                  <tr>
                    <th scope="col">Month</th>
                    <th scope="col">Totals</th>
                    <th scope="col">Agri.</th>
                    <th scope="col">Bus.</th>
                    <th scope="col">Edu./Lib.</th>
                    <th scope="col">Govt.</th>
                    <th scope="col">Health.</th>
                    <th scope="col">K-12</th>
                    <th scope="col">Mfg.</th>
                    <th scope="col">Military</th>
                    <th scope="col">Museum</th>
                    <th scope="col">Other</th>
                    <th scope="col">Pub. Safety</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>January</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(1)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>

                  <tr>
                    <td>February</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(2)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>March</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(3)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>April</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(4)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>May</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(5)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>June</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(6)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>July</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(7)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>August</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(8)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>September</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(9)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>October</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(10)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>November</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(11)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>December</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(12)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>Grand Totals</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(13)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="report-card" style="padding: 20px !important">
            <h2 class="mrauto">Shipped</h2>
            <div class="rfr table-responsive">
              <table
                class="table-striped table-bordered"
                style="text-align: right !important"
              >
                <thead>
                  <tr>
                    <th scope="col">Month</th>
                    <th scope="col">Totals</th>
                    <th scope="col">Agri.</th>
                    <th scope="col">Bus.</th>
                    <th scope="col">Edu./Lib.</th>
                    <th scope="col">Govt.</th>
                    <th scope="col">Health.</th>
                    <th scope="col">K-12</th>
                    <th scope="col">Mfg.</th>
                    <th scope="col">Military</th>
                    <th scope="col">Museum</th>
                    <th scope="col">Other</th>
                    <th scope="col">Pub. Safety</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>January</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(1)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                            territory:
                              report.territory == null ? '' : report.territory,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>February</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(2)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>March</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(3)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>April</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(4)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>May</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(5)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>June</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(6)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>July</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(7)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>August</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(8)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            shippshippedmonth: report.monthEntered,
                            shippshippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>September</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(9)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>October</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(10)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>November</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(11)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>December</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(12)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>Grand Totals</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(13)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            repid: report.repId,
                            territory:
                              report.territory == null ? '' : report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- nothing loaded -->
        <div
          v-else-if="
            loading == false &&
            !reports.salesBySalesman.length &&
            !reports.shippedBySalesman.length &&
            salesPerson == null
          "
          class="col-xs-12 col-sm-12 col-12 col-lg-12 flexVHcenter"
        >
          <div>
            <h2 style="margin: 30px 20px; color: #429da8; font-weight: 400">
              Select an Area Contractor to get started...
            </h2>
            <img src="@/assets/img/selectAC.svg" style="width: 100%" />
          </div>
        </div>

        <!-- couldn't find anything -->
        <div
          v-else-if="
            loading == false && !reports.backlog.length && salesPerson == null
          "
          class="col-xs-12 col-sm-12 col-12 col-lg-12 flexVHcenter"
        >
          <div>
            <h2 style="margin: 30px 20px; color: #429da8; font-weight: 400">
              Sorry, nothing was found...
            </h2>
            <img src="@/assets/img/selectAC.svg" style="width: 100%" />
          </div>
        </div>
      </div>
      <!-- row -->
    </div>
    <!-- container -->
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
// import Avatar from "vue-avatar";
import * as d3 from "d3";
import Arc from "../components/DataViz/Arc.vue";
import { formatCurrency } from '../utils/utils';
//import Bar from "../components/DataViz/BarBackLog";

import BarWhiteMonth from "../components/DataViz/BarWhiteMonth.vue";
import BarWhiteYear from "../components/DataViz/BarWhiteYear.vue";
import BarWhiteMonthShipped from "../components/DataViz/BarWhiteMonthShipped.vue";
import BarWhiteYearShipped from "../components/DataViz/BarWhiteYearShipped.vue";
import reportsrepsTour from "../components/Tours/reportsrepsTour.vue";

const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
    //Authorization: "Bearer thisisanexampleofunauthorized"
  },
};

export default {
  name: "SalesReps",
  components: {
    AtomSpinner,
    // Avatar,
    Arc,
    BarWhiteMonth,
    BarWhiteYear,
    BarWhiteMonthShipped,
    BarWhiteYearShipped,
    reportsrepsTour,
  },
  data() {
    return {
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      server: import.meta.env.VITE_APP_SERVER_URL,
      newHeaderData: [],
      myQueryParam: null,
      backLogTotal: "",
      search: "",
      searchStarted: false,
      reports: [],
      salesPerson: null,
      storedReports: null,
      selectedCat: 0,
      loading: true,
      territoryLoading: false,
      countOfPage: 25,
      currPage: 1,
      noQuestionFound: false,
      territory: "",
      territoryFilter:
        this.$route.query.territory && this.$route.query.territory != "all"
          ? this.$route.query.territory
          : null,
      territories: [],
      countries: [
        { country: "Donnegan", value: 20000.59 },
        { country: "Spacesaver Intermountain", value: 13000.42 },
        { country: "Associated Office Systems", value: 40000.0 },
        { country: "Axiom Inc", value: 4000.9 },
        { country: "Bradford Systems Corporation", value: 2222.88 },
      ],
      userFirst: "",
      userLast: "",
      //ACsGlobal: this.$store.state.acList.acList,
      acs: null,
      acFilter: null,
      acFilterName: null,
      reps: [
        { name: "Bob Smith", value: "bsmith" },
        { name: "Sally Green", value: "sgreen" },
      ],
      repFilter: null,
      markets: [
        { name: "Agriculture", value: "Agriculture" },
        { name: "Business", value: "Business" },
        { name: "Education/Library", value: "Education/Library" },
        { name: "Government", value: "Government" },
        { name: "Healthcare", value: "Healthcare" },
        { name: "Military", value: "Military" },
      ],
      marketFilter: null,
      yearRange: [],
      yearFilter: this.$route.query.year
        ? this.$route.query.year
        : new Date().getFullYear(),
      searchString: "",
      changed: false,
      enteredmtd: false,
      enteredytd: false,
      shippedmtd: false,
      shippedytd: false,
      spacesaverToken: localStorage.getItem("SSCUSER"),
      //monthChartData: reports.quotas,
      monthData: [
        {
          height: "44",
          name: "Grand Totals",
          sales: "3,662,456",
        },
        {
          height: "0",
          name: "Agriculture",
          sales: "0",
        },
        {
          height: "59",
          name: "Business",
          sales: "723,410",
        },
        {
          height: "40",
          name: "Edu/Library",
          sales: "864,888",
        },
        {
          height: "8",
          name: "Military",
          sales: "604,074",
        },
        {
          height: "37",
          name: "Government",
          sales: "230,942",
        },
        {
          height: "48",
          name: "Healthcare",
          sales: "208,951",
        },
        {
          height: "55",
          name: "Museum",
          sales: "311,584",
        },
        {
          height: "46",
          name: "Public Safety",
          sales: "718,607",
        },
        {
          height: "0",
          name: "Other",
          sales: "0",
        },
      ],
      yearData: [
        {
          height: "46",
          name: "Grand Totals",
        },
        {
          height: "22",
          name: "Agriculture",
        },
        {
          height: "66",
          name: "Business",
        },
        {
          height: "49",
          name: "Edu/Library",
        },
        {
          height: "8",
          name: "Military",
        },
        {
          height: "39",
          name: "Government",
        },
        {
          height: "47",
          name: "Healthcare",
        },
        {
          height: "58",
          name: "Museum",
        },
        {
          height: "41",
          name: "Public Safety",
        },
        {
          height: "0",
          name: "Other",
        },
      ],
    };
  },
  methods: {
    firstLoad: function () {
      this.loading = true;
      this.$store.commit("setActivePage", "order-manage");
      this.setFirstLast();
      this.getTerritories("newLoad");
      this.getYears(2008);
      this.acListSync();

      console.log(this.searchEndpointCompute);
      return axios
        .get(`${this.searchEndpointCompute}`, auth)
        .then((response) => {
          //console.log(response);
          this.reports = response.data;
          this.loading = false;
        });
    },

    noCents: function(amount){
      const formattedValue = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(amount);

      return formattedValue;
    },

    acListSync: function () {
      if (!this.$store.state.acList.acList.length) {
        //console.log("getting acList");
        return axios
          .get(`${this.ordermanageapi}/aclist?active=true`, auth)
          .then((response) => {
            //console.log(response);
            const data = response.data;
            /*

            const low = data.filter(function (e) {
              return e.acid < 210;
            });

            const mid = data.filter(function (e) {
              return e.acid == 80069;
            });

            const high = data.filter(function (e) {
              return e.acid > 800000 && e.acid < 800250;
            });

            const all = low.concat(high).concat(mid);
            const alph = all.sort((a, b) => (a.acName > b.acName ? 1 : -1));
            */

            const alph = data.sort((a, b) => (a.acName > b.acName ? 1 : -1));
            this.acs = alph;
            this.$store.commit("UPDATE_ACLIST", this.acs);
          });
      } else {
        //console.log("vuex has length");
        this.acs = this.$store.state.acList.acList;
      }
    },

    formatPrice(amount) {
      return formatCurrency(amount);
    },

    showPerson: function (person, index) {
      //console.log("person " + person );
      //console.log("index " + index );
    },

    formatter: function (str) {
      return str.replace("%20", " ").replace("%26", "&");
    },

    decodeHtmlEntity: function (str) {
      return str.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
      });
    },

    parseHtmlEntities: function (str) {
      return str.replace(/&#([0-9]{1,3});/gi, function (match, numStr) {
        var num = parseInt(numStr, 10); // read num as normal number
        return String.fromCharCode(num);
      });
    },

    getTerritories: function (flag) {
      this.changed = true;
      //this.territory = null;

      /*
      if(flag != 'newLoad'){
        //prevents a reset if a GET variable is used
        this.territoryFilter = null;
        this.repFilter = null;
      }  
*/
      let tString;

      if (this.acFilter != null && this.yearFilter != null) {
        // has both
        tString = `${this.ordermanageapi}/territory?acid=${this.acFilter}&year=${this.yearFilter}`;
      } else {
        tString = `${this.ordermanageapi}/territory?acid=${this.acFilter}`;
      }

      this.$forceUpdate();
      //console.log(`${tString}`);

      if (this.acFilter != null) {
        this.territoryLoading = true;

        return axios
          .get(`${tString}`, auth)
          .then((response) => {
            this.territories = response.data.territories;
            this.territoryLoading = false;
          })
          .then(() => {
            return axios
              .get(
                `${this.ordermanageapi}/salespeople?ac=${this.acFilter}`,
                auth
              )
              .then((response) => {
                this.reps = response.data.salesPeople;
              });
          });
      }
    },

    setTerritory: function () {
      this.$forceUpdate();
      //console.log("setting territory");

      if (
        this.territoryFilter !== null ||
        this.territoryFilter !== "Other" ||
        this.territoryFilter !== "All Territories"
      ) {
        this.territory = this.territoryFilter;
      } else {
        this.territory = "";
      }
    },

    searchQuery(event) {
      this.searchStarted = true;
      this.changed = false;
      history.pushState(
        {},
        "",
        `/reports/sales-reps?ac=${this.acFilter}&year=${
          this.yearFilter
        }&territory=${
          this.territoryFilter == null ? "all" : this.territoryFilter
        }&rep=${this.repFilter}`
      );
      this.search = "";
      this.loading = true;
      //this.searching = true;
      if (
        this.territoryFilter !== null ||
        this.territoryFilter !== "Other" ||
        this.territoryFilter !== "All Territories"
      ) {
        this.territory = this.territoryFilter;
      } else {
        this.territory = "";
      }

      this.$forceUpdate();
      //this.searchString = `${this.acFilterName} ${this.yearFilter} ${this.territoryFilter}`;
      //console.log("hitting this " + `${this.searchEndpointCompute}`);

      //get all the reps and show the normal page
      if (this.repFilter == null) {
        //console.log('all the reps');
        return axios.get(this.searchEndpointCompute, auth).then((response) => {
          this.salesPerson = null;
          this.reports = response.data;
          //console.log(response);
          this.loading = false;
          //this.searching = false;
        });
      } else {
        //console.log('one rep');
        //console.log(`${this.ordermanageapi}/reportbyind?&acid=${this.acFilter}&repid=${this.repFilter}&territory=${this.territoryFilter == null ? '' : this.territoryFilter}&year=${this.yearFilter}`);
        //get all the reps and show the normal page
        return axios
          .get(
            `${this.ordermanageapi}/reportbyind?&acid=${this.acFilter}&repid=${
              this.repFilter
            }&territory=${
              this.territoryFilter == null ? "" : this.territoryFilter
            }&year=${this.yearFilter}`,
            auth
          )
          .then((response) => {
            this.salesPerson = response.data;
            this.loading = false;
            //console.log(response);
            this.reports.backlog = this.salesPerson.backlog;
            //this.searching = false;
          });
      }
    },

    clearSearch() {
      //this.closeCharts();
      this.loading = true;
      this.reports.salesBySalesman = [];
      this.reports.shippedBySalesman = [];
      if (this.searchStarted == true) {
        //this.reports = this.storedReports;
        this.searchStarted = false;
      }
      this.searchValue = "";
      this.searchRender = !this.searchRender;
      this.acFilterName = null;
      this.repFilter = null;
      this.acFilter = null;
      this.salesPerson = null;
      this.reps = [];
      this.territories = [];
      this.yearFilter = new Date().getFullYear();
      this.territoryFilter = null;
      this.getTerritories();
      this.searchString = "";
      this.changed = false;

      axios.get(`${this.searchEndpointCompute}`, auth).then((response) => {
        //console.log(response);
        this.reports = response.data;
        this.loading = false;
        this.$forceUpdate();
        history.pushState({}, "", `/reports/sales-reps`);
      });
    },

    setFirstLast() {
      this.userFirst = this.firstName;
      this.userLast = this.lastName;
    },

    rowTotal: function (month) {
      let m = month;
      let total = m.reduce(function (prev, cur) {
        return prev + cur.salesCredit;
      }, 0);
      return total;
    },

    // Returns a new array of objects made up of full names.
    getYears: function (startYear) {
      let currentYear = new Date().getFullYear(),
        years = [];
      startYear = startYear || 1980;
      while (startYear <= currentYear) {
        years.push(startYear++);
      }
      let yearsDesc = years.reverse();
      this.yearRange = yearsDesc;
      //return yearsDesc;
    },

    setACFilterName: function (ac) {
      //v-on:change="getTerritories()"
      //getTerritories();
      this.acFilterName = ac;
      //console.log(ac);
    },

    enteredMonth: function (month) {
      return this.salesPerson.entered.filter(
        (report) => report.monthEntered === month
      );
    },

    shippedMonth: function (month) {
      return this.salesPerson.shipped.filter(
        (report) => report.monthEntered === month
      );
    },

    getSalesmanTotal: function (name) {
      let block = this.reports.salesBySalesman.filter(
        (report) => report.salesman_Name === name
      );
      return block[0].salescredit;
    },

    getSalesmanShippedTotal: function (name) {
      let block = this.reports.shippedBySalesman.filter(
        (report) => report.salesman_Name === name
      );
      return block[0].salescredit;
    },

    getMonthSales: function (name, month) {
      let allMonths = this.reports.salesBySalesman.filter(
        (report) => report.salesman_Name === name
      );
      let oneMonth = allMonths.filter(
        (monthSales) => monthSales.monthentered === month
      );
      return oneMonth[0].salescredit;
    },

    getMonthShipped: function (name, month) {
      let allMonths = this.reports.shippedBySalesman.filter(
        (report) => report.salesman_Name === name
      );
      let oneMonth = allMonths.filter(
        (monthSales) => monthSales.monthentered === month
      );
      return oneMonth[0].salescredit;
    },

    getRepId: function (name, month) {
      let allMonths = this.reports.salesBySalesman.filter(
        (report) => report.salesman_Name === name
      );
      let oneMonth = allMonths.filter(
        (monthSales) => monthSales.monthentered === month
      );
      // console.log(oneMonth[0].repid)
      return oneMonth[0].repid;
    },
    getRepIdShipped: function (name, month) {
      let allMonths = this.reports.shippedBySalesman.filter(
        (report) => report.salesman_Name === name
      );
      let oneMonth = allMonths.filter(
        (monthSales) => monthSales.monthentered === month
      );
      // console.log(oneMonth[0].repid)
      return oneMonth[0].repid;
    },

  },

  computed: {
    activeNav() {
      return this.$store.state.activePage;
    },
    getUniqueEnteredNames: function () {
      if (this.loading == false && this.reports.salesBySalesman.length) {
        const unique = [
          ...new Set(
            this.reports.salesBySalesman.map((item) => item.salesman_Name)
          ),
        ];
        return unique;
      } else {
        return [];
      }
    },
    getUniqueShippedNames: function () {
      if (this.loading == false && this.reports.shippedBySalesman.length) {
        const unique = [
          ...new Set(
            this.reports.shippedBySalesman.map((item) => item.salesman_Name)
          ),
        ];
        return unique;
      } else {
        return [];
      }
    },

    calcACName() {
      if (this.acFilter !== null) {
        let acNum = this.acFilter;
        let selectedACName = this.acs.filter(function (ac) {
          return ac.acid == acNum;
        });

        this.acFilterName = selectedACName[0].acName;
        return selectedACName[0].acName;
        //return selectedACName;
        //this.acFilterName = selectedACName.acName;
      } else {
        return null;
      }
    },

    userToken() {
      return this.$store.state.token;
    },

    reformatBackLogHeaderData: function () {
      if (!this.loading) {
        const formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        });

        // strip out the first
        let filtered = this.reports.backlog.filter(function (
          value,
          index,
          arr
        ) {
          return value.state != "Backlog";
        });
        //let newData = this.reports.backlog.shift();
        return filtered.map(function (i) {
          // create a new object to store full name.
          var newObj = {};
          newObj["sales"] = formatter.format(i.sales);
          newObj["number"] = i.sales;
          newObj["state"] = i.state;
          return newObj;
          //console.log(newData);
        });
      } else {
        return [];
      }
    },

    headerSync: function () {
      if (this.reformatBackLogHeaderData.length) {
        this.newHeaderData = this.reformatBackLogHeaderData;
      } else {
        return;
      }
    },
    backlogTotalSync: function () {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      if (this.reports.backlog[0].sales) {
        this.backLogTotal = formatter.format(this.reports.backlog[0].sales);
      } else {
        this.backLogTotal = "";
      }
    },
    //Grand
    enteredGrand: function () {
      //return this.reports.entered.filter((report) => report.Market === " Grand");
      return this.reports.entered.slice(120, 130);
    },
    shippedGrand: function () {
      //return this.reports.entered.filter((report) => report.Market === " Grand");
      return this.reports.shipped.slice(120, 130);
    },
    searchEndpointCompute: function () {
      //this.ordermanageapi}/salesreport ?year=2021 &acid=141
      if (
        this.acFilter != null &&
        this.yearFilter != null &&
        this.territoryFilter != null &&
        this.repFilter != null
      ) {
        // All four
        return `${this.ordermanageapi}/salesreport?year=${this.yearFilter}&acid=${this.acFilter}&territory=${this.territoryFilter}&repid=${this.repFilter}`;
        //https://ordermanage.spacesaver.com/salesreport?year=2021&acid=8&territory=Michigan&repid=8059
      } else if (
        this.acFilter != null &&
        this.yearFilter == null &&
        this.territoryFilter != null &&
        this.repFilter != null
      ) {
        //three selected no year
        return `${
          this.ordermanageapi
        }/salesreport?year=${new Date().getFullYear()}&acid=${
          this.acFilter
        }&territory=${this.territoryFilter}&repid=${this.repFilter}`;
      } else if (
        this.acFilter != null &&
        this.yearFilter != null &&
        this.territoryFilter != null &&
        this.repFilter == null
      ) {
        // no sales rep
        return `${
          this.ordermanageapi
        }/salesreport?year=${new Date().getFullYear()}&acid=${
          this.acFilter
        }&territory=${this.territoryFilter}`;
      } else if (
        this.acFilter != null &&
        this.yearFilter != null &&
        this.territoryFilter == null &&
        this.repFilter != null
      ) {
        // no territory, has sales rep
        return `${this.ordermanageapi}/salesreport?year=${this.yearFilter}&acid=${this.acFilter}&repid=${this.repFilter}`;
      } else if (
        this.acFilter != null &&
        this.yearFilter != null &&
        this.territoryFilter == null &&
        this.repFilter == null
      ) {
        // no territory, no sales rep
        return `${this.ordermanageapi}/salesreport?year=${this.yearFilter}&acid=${this.acFilter}`;
      } else {
        /*
      else if (this.acFilter != null && this.yearFilter != null && this.territoryFilter == null) {
        // both ac and year and no territory
        return `${this.ordermanageapi}/salesreport?year=${this.yearFilter}&acid=${this.acFilter}`;
        
      } 
      */
        return `${this.ordermanageapi}/salesreport`;
      }
    },
    acInput() {
      return parse(this.acFilter);
    },
  },
  created() {
    this.$store.commit("showNavigation");
    //checkTerritoryQ();

    if (this.$route.query.ac) {
      let parameters = this.$route.query;
      //console.log(parameters.ac)
      this.acFilter = parameters.ac;
    } else {
      this.acFilter = null;
    }

    /*
    if (this.$route.params.ac) {
      history.pushState({}, '', `/pagepath/path?ac=${this.myQueryParam}`);
      console.log(this.$route.path);
      //this.this.pageSlug = this.$route.params.slug;
    }
    */

    // console.log(this.$route.path);
    // console.log(this.$route.path);
  },
  mounted() {
    this.firstLoad();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.report-card {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  overflow: scroll;
}
.fromfortbg {
  background-color: rgba(92, 109, 126, 0.9);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 1600 800'%3E%3Cg fill-opacity='0.2'%3E%3Cg fill='%23262626'%3E%3Cpolygon points='1600 800 1400 800 1600 0'/%3E%3Cpolygon points='800 800 1600 600 1600 800'/%3E%3C/g%3E%3Cg fill='%23262626'%3E%3Cpolygon points='0 0 200 0 0 800'/%3E%3Cpolygon points='800 0 0 200 0 0'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
.pixelsbg {
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23505a65'/%3E%3Cstop offset='1' stop-color='%23505a65' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233f474f'/%3E%3Cstop offset='1' stop-color='%233f474f' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23383e45'/%3E%3Cstop offset='1' stop-color='%23383e45' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%23474f58' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%23464f58' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%23464e57' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%23454e56' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23454d56' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%23444d55' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%23444c55' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%23434b54' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%23434b53' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23424a53' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23424a52' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23404850' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23404750' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%233f474f' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%233e454d' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%233e454c' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%233d444c' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%233d444b' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%233c434b' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%233c424a' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%233b4249' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%233b4149' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%233a4148' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%233a4047' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%23394047' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%23393f46' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%23383f46' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%23394047' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%233b4148' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%233c434a' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%233d444c' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%233f464e' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%2340474f' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23414951' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23434a53' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23444c55' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%23454d57' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%23474f58' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%2348515a' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%2349525c' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%234b545e' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%234c5560' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%234d5761' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%234f5963' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%23505a65' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%23515c67' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%23535d69' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%23545f6b' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2355616c' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2357626e' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%23586470' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%235a6672' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%235b6774' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%235c6976' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b78' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%235f6c7a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23616e7c' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%2362707d' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%2363717f' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23657381' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23667583' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23687685' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525b' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c555f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5660' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234d5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234e5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%234f5a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23505b65' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%23545f6a' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355606c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356616d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636e' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6773' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235c6976' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235d6a77' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%235f6d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23606e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23616f7c' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647280' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657382' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%23383e45' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='.5'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233c768a'/%3E%3Cstop offset='1' stop-color='%233c768a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23305e6e'/%3E%3Cstop offset='1' stop-color='%23305e6e' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%2346505a' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%2344515c' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%2343515d' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%2341525e' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23405260' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%233e5361' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%233d5462' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%233c5463' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%233a5565' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23395666' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23375767' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23365969' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23345a6a' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23335b6b' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23325d6c' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%23305e6e' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%232f606f' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%232d6170' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%232c6372' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%232b6573' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%23296774' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%23286975' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%23266b77' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%23256d78' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%23246f79' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%2322727a' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%2321747c' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%2320767d' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%231e797e' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%231d7c80' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%231b7e81' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%231c8083' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%231d8083' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%231f7f84' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%23217e85' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%23227e85' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%23247d86' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23267c87' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23287c87' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23297b88' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%232b7a88' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%232d7a88' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%232f7989' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%23317989' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%23337889' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%2335788a' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%2337778a' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%233a778a' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%233c768a' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%233e768a' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%2340758a' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%2343758a' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2345758a' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2347758a' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%234a758a' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%234c748a' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%234e748a' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%2351748a' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%2354758a' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%2356758a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23597589' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%235b7589' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%235e7689' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23617688' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23637788' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23667787' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525c' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c565f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5761' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234e5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234f5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%23505a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23515b66' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%2354606b' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355616c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356626d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636f' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6774' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235d6a76' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235e6b78' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235f6c79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%23606d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23616e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23626f7d' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647281' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657482' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%231a8182' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='0.79'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
.table-responsive {
  display: table;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #e8e8e8 !important;
}
.badge-success {
  color: #fff;
  background-color: #4d5967;
  background-color: #1eb5b6;
}
.table-striped a {
  color: #00b4b4;
}
.table-striped td,
.table-striped th {
  padding: 5px;
  font-weight: 300 !important;
  font-size: 13px !important;
}
.listing {
  border-radius: 4px;
}
table td {
  line-height: 1;
}
.table-striped th {
  background: #00b4b4;
  background: #4d5967;
  color: #fff;
}
.table-striped {
  min-width: 100%;
  overflow: scroll;
}
.text-white {
  color: #fff;
}
.disclaimer {
  padding: 0;
  font-style: italic;
}
.search-btns {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 0;
  margin-bottom: 10px;
}
select.form-control[data-v-639340da]:not([size]):not([multiple]) {
  height: auto !important;
  padding: 10px !important;
  color: #757575 !important;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.all-contractors {
  color: #757575 !important;
}
.mrauto {
  margin-right: auto;
}
.search-btns {
  display: flex;
  margin-top: 0;
  margin-bottom: 0;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  max-height: 40px;
}
.search-btns .clear {
  margin-left: auto;
}
.search-btns .search {
  margin-left: 5px;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}
.top-titles {
  font-weight: 400;
}
.top-back {
  display: inline-block;
  padding: 10px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border-radius: 4px;
  transition: background 0.5s ease;
  text-decoration: none;
}
.top-back span {
  font-size: 16px;
}

.top-back:hover {
  background: hsla(0, 0%, 100%, 0.4);
  cursor: pointer;
}
.top-back:active {
  background: hsla(0, 0%, 100%, 0.4);
  cursor: pointer;
}
.backlog-back {
  text-decoration: none;
}
.f-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.h-100 {
  height: 100%;
}
.box-hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.row-4 {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex: 1;
}

/*
@media (max-width:767px) {
  .top-back {
    flex-basis: calc(50% - 12px);
  }
}

@media (max-width:560px) {
  .top-back {
    flex-basis: 100%;
  }
}
*/

.header-bucket-wrap {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  padding-right: 10px;
}
.mb10 {
  margin-bottom: 10px;
}

.left-side {
  display: flex;
  flex-grow: 1;
}

.ac-select {
  transition: width 1s ease-in-out;
}
@media only screen and (max-width: 991px) {
  .left-side {
    display: block;
  }
}

@media only screen and (min-width: 992px) {
  #year {
    width: 40px !important;
    overflow: hidden;
  }
  .select-ac {
    flex: 0 0 200px;
  }
  .select-year {
    flex: 0 0 100px;
  }
  .select-territory {
    flex: 0 0 200px;
  }
}

@media only screen and (min-width: 1165px) {
  #year {
    width: 40px !important;
    overflow: hidden;
  }
  .select-ac {
    flex: 0 0 300px;
  }
  .select-year {
    flex: 0 0 100px;
  }
  .select-territory {
    flex: 0 0 150px;
  }
}

@media only screen and (min-width: 992px) {
  .right-space {
    margin-right: 10px;
  }
}

.dropdown-menu {
  background-color: rgba(50, 50, 50, 0.8);
  color: #fff;
}
.dropdown-item:focus,
.dropdown-item:hover {
  color: #16181b;
  text-decoration: none;
  background-color: rgba(100, 100, 100, 0.6);
}
html {
  scroll-behavior: smooth;
}
.list-btn {
  padding: 5px 10px 5px 2px !important;
}
.ac-select {
  margin-bottom: 10px;
}
.reportLink{
  color: rgb(0, 180, 180)!important;
}
.reportLink:visited{
  color: rgb(0, 180, 180)!important;
}
.pixelsbggrid {
  background-color: #475059;
  background-size: cover;
  background-position: center;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200' preserveAspectRatio='xMidYMid slice'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%2356626d'/%3E%3Cstop offset='1' stop-color='%2356626d' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%2337778a'/%3E%3Cstop offset='1' stop-color='%2337778a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%232b5c60'/%3E%3Cstop offset='1' stop-color='%232b5c60' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23667787'/%3E%3Cstop offset='1' stop-color='%23667787' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3ClinearGradient id='base' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='.5' stop-color='%2356626d'/%3E%3Cstop offset='1' stop-color='%231a8182'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect fill='%23475059' width='1950' height='1200'/%3E%3Crect fill='url(%23base)' width='1950' height='1200'/%3E%3Cline x1='0' y1='0' x2='0' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='50' y1='0' x2='50' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='100' y1='0' x2='100' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='150' y1='0' x2='150' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='200' y1='0' x2='200' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='250' y1='0' x2='250' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='300' y1='0' x2='300' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='350' y1='0' x2='350' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='400' y1='0' x2='400' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='450' y1='0' x2='450' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='500' y1='0' x2='500' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='550' y1='0' x2='550' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='600' y1='0' x2='600' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='650' y1='0' x2='650' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='700' y1='0' x2='700' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='750' y1='0' x2='750' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='800' y1='0' x2='800' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='850' y1='0' x2='850' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='900' y1='0' x2='900' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='950' y1='0' x2='950' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1000' y1='0' x2='1000' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='1050' y1='0' x2='1050' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1100' y1='0' x2='1100' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1150' y1='0' x2='1150' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1200' y1='0' x2='1200' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1250' y1='0' x2='1250' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='1300' y1='0' x2='1300' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1350' y1='0' x2='1350' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1400' y1='0' x2='1400' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1450' y1='0' x2='1450' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1500' y1='0' x2='1500' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='1550' y1='0' x2='1550' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1600' y1='0' x2='1600' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1650' y1='0' x2='1650' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1700' y1='0' x2='1700' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1750' y1='0' x2='1750' y2='1200' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='1800' y1='0' x2='1800' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1850' y1='0' x2='1850' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='1900' y1='0' x2='1900' y2='1200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='0' x2='1950' y2='0' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='50' x2='1950' y2='50' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='100' x2='1950' y2='100' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='150' x2='1950' y2='150' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='200' x2='1950' y2='200' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='250' x2='1950' y2='250' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='300' x2='1950' y2='300' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='350' x2='1950' y2='350' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='400' x2='1950' y2='400' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='450' x2='1950' y2='450' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='500' x2='1950' y2='500' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='550' x2='1950' y2='550' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='600' x2='1950' y2='600' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='650' x2='1950' y2='650' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='700' x2='1950' y2='700' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='750' x2='1950' y2='750' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='800' x2='1950' y2='800' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='850' x2='1950' y2='850' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='900' x2='1950' y2='900' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='950' x2='1950' y2='950' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='1000' x2='1950' y2='1000' stroke='%23fff' stroke-opacity='0.12' stroke-width='2'/%3E%3Cline x1='0' y1='1050' x2='1950' y2='1050' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='1100' x2='1950' y2='1100' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cline x1='0' y1='1150' x2='1950' y2='1150' stroke='%23fff' stroke-opacity='0.05' stroke-width='1'/%3E%3Cg fill-opacity='0.45'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
}
</style>
